<template>
  <section class="cta-section">
    <div class="cta-section__top">
      <h2 class="cta-section__top__title">{{ title }}</h2>
      <div class="cta-section__top__pdf-title">
        {{ pdfTitle }}
      </div>
    </div>

    <img
      :src="`${$baseUrl}images/${$t('translation.' + currentPage)}_pdf-cover-${i18n.locale.value}.webp`"
      alt=""
      class="cta-section__image"
    />

    <div class="cta-section__bottom">
      <ButtonPrimary
        :label="
          $t(
            'general.ctas.' +
              (currentPage === 'home' ? 'downloadPDF' : 'downloadChapterPDF')
          )
        "
        :url="pdfLink"
      />
      <ButtonPrimary
        :label="$t('general.ctas.toDownload')"
        internalUrlParam="download-multimedia"
        white
      />
    </div>
  </section>
</template>

<script setup>
import { inject } from "vue";
import { useI18n } from "vue-i18n";

import ButtonPrimary from "../general/ButtonPrimary.vue";

defineProps({
  title: String,
  pdfTitle: String,
  currentPage: String,
  pdfLink: String,
  pdfSize: String
});

const $baseUrl = inject("$baseUrl");
const i18n = useI18n();
</script>

<style lang="scss" scoped>
.cta-section {
  --section-padding-v-t: 14vh;
  --section-padding-v-b: calc(var(--section-padding-v-t) * 0.5);

  border-top: 1px solid var(--page-color);

  .mobile &,
  .tablet & {
    --section-padding-v-t: 7vh;
  }

  position: relative;

  &__top {
    padding: var(--section-padding-v-t) 7vw var(--section-padding-v-b)
      var(--page-padding-h);

    .large &,
    .desktop & {
      width: 50%;
    }

    .mobile &,
    .tablet & {
      text-align: center;
    }

    &__title {
      .large &,
      .desktop & {
        @include h-h-2;

        margin-bottom: 1.65rem;
      }

      .mobile &,
      .tablet & {
        @include h-h-3;

        margin-bottom: toRem(10);
      }
    }

    &__pdf-title {
      .large &,
      .desktop & {
        @include title-m;

        margin-bottom: 1rem;
      }

      .mobile &,
      .tablet & {
        @include title-s;

        margin-bottom: toRem(10);
      }
    }

    &__pdf-size {
      .mobile &,
      .tablet & {
        @include p-s;
      }
    }
  }

  &__bottom {
    background-image: var(--page-gradient);
    padding: var(--section-padding-v-b) var(--page-padding-h)
      var(--section-padding-v-t);

    .mobile &,
    .tablet & {
      margin-top: -2.5rem;
      padding: calc(var(--section-padding-v-b) + 2.5rem) var(--page-padding-h)
        var(--section-padding-v-t);
    }

    > * {
      display: block;

      .mobile &,
      .tablet & {
        margin: 0 auto;
      }

      &:not(:last-child) {
        margin-bottom: 1.25rem;
      }
    }
  }

  &__image {
    .desktop &,
    .large & {
      position: absolute;
      top: var(--section-padding-v-t);
      right: var(--page-padding-h);
      height: calc(100% - var(--section-padding-v-t) * 2);
    }

    .mobile &,
    .tablet & {
      width: 80%;
      display: block;
      margin: 0 auto;
    }
  }
}
</style>
